import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';
import { UUID } from '../../util/prototypes';
import { CustomClass } from './custom-class.model'


export class GradientColor {
    constructor({ color }) {
        this.color = color;
        this.id = UUID();
    }

    toJson() {
        return {
            color: this.color,
            id: this.id
        }
    }
}

export class Gradient extends CustomClass {

    constructor(payload) {
        super(payload);
        if (payload) {
            this.colors = payload.colors;
            this.degree = payload.degree ? payload.degree : 90;
        } else {
            this.colors = [];
            this.degree = 90;
        }
    }

    get style() {
        const count = this.colors.length;
        const grad = `linear-gradient(${this.degree ? this.degree : '90'}deg,${this.colors
            .map(
                (item, i) =>
                    `${item.color} ${Math.round((i * 100) / this.colors.length)}%`
            )
            .join(",")} )`;
        return count ? grad : "";
    }


    get className() {
        return `.${this.name}{background:${this.style}}`;
    }

    static loadGradientsToDom(callback) {
        const stylsheet = document.createElement("style");
        stylsheet.setAttribute("type", "text/css");
        stylsheet.setAttribute("id", "customStyle");
        Gradient.list((grads) => {
            const css = grads.map((grad) => grad.className).join(' ');
            stylsheet.innerText = css;
            document.querySelector("head").appendChild(stylsheet);
            callback(grads);
        })
    }

    addColor(color) {
        this.colors.push(color);
    }

    removeColor(color) {
        this.colors = this.colors.filter((item) => item.id !== color.id);
    }

    changeColor(itemColor, color) {
        this.colors.forEach((item) => {
            if (item.id !== itemColor.id) {
                item.color = color;
            }
        });
    }

    static list(callback) {
        AppService.allGradientsOnChange((snapshot) => {
            this.snapshot = snapshot;
            const list = [];
            snapshot.docs.forEach((item) => {
                const data = item.data();
                list.push(new Gradient({ ...data, doc: item }))
            })
            callback(list);
        });
    }

    static async saveLocal() {
        const resp = await Gradient.list();
        const localList = resp.map((item) => item.toJson());
        localStorage.setItem('localData', JSON.stringify(localList));
    }


    async create() {
        try {
            const data = {
                colors: this.colors.map((item) => item.toJson()),
                name: `grad-${this.name.toLowerCase()}`,
                timestamp: this.timestamp,
                uid: this.user.uid,
                user: this.user.toJson(),
                degree: this.degree
            };
            const resp = await AppService.addGradient(data);
            this.doc = resp;
            return this;
        } catch (error) {
            console.error("Error in Gradient.create", error);
            throw error;
        }
    }

}

